// extracted by mini-css-extract-plugin
module.exports = {"change-password-input":"style_change-password-input__U0Tfe"};